import { render, staticRenderFns } from "./AddGiftPopup.vue?vue&type=template&id=e7ed452a&"
import script from "./AddGiftPopup.vue?vue&type=script&lang=js&"
export * from "./AddGiftPopup.vue?vue&type=script&lang=js&"
import style0 from "./AddGiftPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports